"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _redraft = _interopRequireDefault(require("redraft"));

var _Themes = _interopRequireDefault(require("./Themes"));

var _FooterImages = require("./../plugins/footerPlugin/FooterImages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var selectedTheme = _Themes["default"]['default'];

var inlineSpan = function inlineSpan(key, themeClass, children) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: key,
    style: selectedTheme[themeClass]
  }, children);
};

var inline = {
  BOLD: function BOLD(children, _ref) {
    var key = _ref.key;
    return /*#__PURE__*/_react["default"].createElement("strong", {
      key: key
    }, children);
  },
  ITALIC: function ITALIC(children, _ref2) {
    var key = _ref2.key;
    return /*#__PURE__*/_react["default"].createElement("em", {
      key: key
    }, children);
  },
  UNDERLINE: function UNDERLINE(children, _ref3) {
    var key = _ref3.key;
    return /*#__PURE__*/_react["default"].createElement("u", {
      key: key
    }, children);
  },
  CODE: function CODE(children, _ref4) {
    var key = _ref4.key;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: key,
      style: selectedTheme['code']
    }, children);
  },
  CUSTOM_ADDCOLOR_ONE: function CUSTOM_ADDCOLOR_ONE(children, _ref5) {
    var key = _ref5.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_ONE', children);
  },
  CUSTOM_ADDCOLOR_TWO: function CUSTOM_ADDCOLOR_TWO(children, _ref6) {
    var key = _ref6.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_TWO', children);
  },
  CUSTOM_ADDCOLOR_THR: function CUSTOM_ADDCOLOR_THR(children, _ref7) {
    var key = _ref7.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_THR', children);
  },
  CUSTOM_ADDCOLOR_FUR: function CUSTOM_ADDCOLOR_FUR(children, _ref8) {
    var key = _ref8.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_FUR', children);
  },
  CUSTOM_ADDCOLOR_FVE: function CUSTOM_ADDCOLOR_FVE(children, _ref9) {
    var key = _ref9.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_FVE', children);
  },
  CUSTOM_ADDCOLOR_SIX: function CUSTOM_ADDCOLOR_SIX(children, _ref10) {
    var key = _ref10.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_SIX', children);
  },
  CUSTOM_ADDCOLOR_SVN: function CUSTOM_ADDCOLOR_SVN(children, _ref11) {
    var key = _ref11.key;
    return inlineSpan(key, 'CUSTOM_ADDCOLOR_SVN', children);
  },
  CUSTOM_ADD_FONT_FAMILY_ONE: function CUSTOM_ADD_FONT_FAMILY_ONE(children, _ref12) {
    var key = _ref12.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_ONE', children);
  },
  CUSTOM_ADD_FONT_FAMILY_TWO: function CUSTOM_ADD_FONT_FAMILY_TWO(children, _ref13) {
    var key = _ref13.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_TWO', children);
  },
  CUSTOM_ADD_FONT_FAMILY_THR: function CUSTOM_ADD_FONT_FAMILY_THR(children, _ref14) {
    var key = _ref14.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_THR', children);
  },
  CUSTOM_ADD_FONT_FAMILY_FUR: function CUSTOM_ADD_FONT_FAMILY_FUR(children, _ref15) {
    var key = _ref15.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_FUR', children);
  },
  CUSTOM_ADD_FONT_FAMILY_FIV: function CUSTOM_ADD_FONT_FAMILY_FIV(children, _ref16) {
    var key = _ref16.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_FIV', children);
  },
  CUSTOM_ADD_FONT_FAMILY_SIX: function CUSTOM_ADD_FONT_FAMILY_SIX(children, _ref17) {
    var key = _ref17.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_SIX', children);
  },
  CUSTOM_ADD_FONT_FAMILY_SVN: function CUSTOM_ADD_FONT_FAMILY_SVN(children, _ref18) {
    var key = _ref18.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_SVN', children);
  },
  CUSTOM_ADD_FONT_FAMILY_EGT: function CUSTOM_ADD_FONT_FAMILY_EGT(children, _ref19) {
    var key = _ref19.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_EGT', children);
  },
  CUSTOM_ADD_FONT_FAMILY_NNE: function CUSTOM_ADD_FONT_FAMILY_NNE(children, _ref20) {
    var key = _ref20.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_NNE', children);
  },
  CUSTOM_ADD_FONT_FAMILY_TEN: function CUSTOM_ADD_FONT_FAMILY_TEN(children, _ref21) {
    var key = _ref21.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_TEN', children);
  },
  CUSTOM_ADD_FONT_FAMILY_ELE: function CUSTOM_ADD_FONT_FAMILY_ELE(children, _ref22) {
    var key = _ref22.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_ELE', children);
  },
  CUSTOM_ADD_FONT_FAMILY_TWE: function CUSTOM_ADD_FONT_FAMILY_TWE(children, _ref23) {
    var key = _ref23.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_TWE', children);
  },
  CUSTOM_ADD_FONT_FAMILY_THT: function CUSTOM_ADD_FONT_FAMILY_THT(children, _ref24) {
    var key = _ref24.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_THT', children);
  },
  CUSTOM_ADD_FONT_FAMILY_FTN: function CUSTOM_ADD_FONT_FAMILY_FTN(children, _ref25) {
    var key = _ref25.key;
    return inlineSpan(key, 'CUSTOM_ADD_FONT_FAMILY_FTN', children);
  }
};

var getAtomic = function getAtomic(children, _ref26) {
  var keys = _ref26.keys;
  return children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: keys[index]
    }, /*#__PURE__*/_react["default"].createElement("td", null, child));
  }); //console.debug(details);
};
/*data.map(
  (item, i) => <tr>
      <td><AtomicBlock key={keys[i]} {...data[i]} theme={selectedTheme} /></td>
  </tr>
);*/


var addBreaklines = function addBreaklines(children) {
  return children.map(function (child) {
    return [child, /*#__PURE__*/_react["default"].createElement("br", null)];
  });
};

var addAlignment = function addAlignment(styles, data) {
  if (data && data['text-align']) {
    return Object.assign({}, styles, selectedTheme[data['text-align']]);
  }

  return styles;
};
/**
 * Note that children can be maped to render a list or do other cool stuff
 */


var blocks = {
  // Rendering blocks like this along with cleanup results in a single p tag for each paragraph
  // adding an empty block closes current paragraph and starts a new one
  unstyled: function unstyled(children, _ref27) {
    var data = _ref27.data,
        keys = _ref27.keys;
    return children.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        style: addAlignment(selectedTheme['text-content'], data[index]),
        key: keys[index]
      }, child, /*#__PURE__*/_react["default"].createElement("br", null)));
    });
  },
  atomic: getAtomic,
  blockquote: function blockquote(children, _ref28) {
    var keys = _ref28.keys,
        data = _ref28.data;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['text-content']
    }, children.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement("blockquote", {
        key: keys[index],
        style: addAlignment(selectedTheme['blockquote'], data[index])
      }, child);
    })));
  },
  'header-one': function headerOne(children, _ref29) {
    var keys = _ref29.keys,
        data = _ref29.data;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['title-content']
    }, children.map(function (child, i) {
      return /*#__PURE__*/_react["default"].createElement("h1", {
        style: addAlignment(selectedTheme['title'], data[i]),
        key: keys[i]
      }, child);
    })));
  },
  'header-two': function headerTwo(children, _ref30) {
    var keys = _ref30.keys,
        data = _ref30.data;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['title-content']
    }, children.map(function (child, i) {
      return /*#__PURE__*/_react["default"].createElement("h2", {
        style: addAlignment(selectedTheme['sub-title'], data[i]),
        key: keys[i]
      }, child);
    })));
  },
  'code-block': function codeBlock(children, _ref31) {
    var keys = _ref31.keys;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['codeBlock']
    }, /*#__PURE__*/_react["default"].createElement("pre", {
      key: keys[0]
    }, addBreaklines(children))));
  },
  'unordered-list-item': function unorderedListItem(children, _ref32) {
    var depth = _ref32.depth,
        keys = _ref32.keys,
        data = _ref32.data;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: addAlignment(selectedTheme['text-content'], data[0])
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      key: keys[keys.length - 1],
      className: "ul-level-" + depth
    }, children.map(function (child) {
      return /*#__PURE__*/_react["default"].createElement("li", null, child);
    }))));
  },
  'ordered-list-item': function orderedListItem(children, _ref33) {
    var depth = _ref33.depth,
        keys = _ref33.keys,
        data = _ref33.data;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: addAlignment(selectedTheme['text-content'], data[0])
    }, /*#__PURE__*/_react["default"].createElement("ol", {
      key: keys.join('|'),
      className: "ol-level-" + depth
    }, children.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: keys[index]
      }, child);
    }))));
  }
};

var imageComponent = function imageComponent(src) {
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: src,
    style: {
      width: '100%'
    },
    alt: "custom"
  });
};

var buttonComponent = function buttonComponent(name, size) {
  return /*#__PURE__*/_react["default"].createElement("button", {
    style: _extends({}, selectedTheme['button'], selectedTheme["button-" + size])
  }, name);
};

var entities = {
  LINK: function LINK(children, entity, _ref34) {
    var key = _ref34.key;
    return /*#__PURE__*/_react["default"].createElement("a", {
      key: key,
      href: entity.url
    }, children);
  },
  IMAGE: function IMAGE(children, _ref35, _ref36) {
    var src = _ref35.src,
        alignment = _ref35.alignment,
        width = _ref35.width,
        linkToUrl = _ref35.linkToUrl;
    var key = _ref36.key,
        data = _ref36.data;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      style: _extends({
        width: width + "%"
      }, selectedTheme['ALIGN_BLOCK_' + alignment])
    }, linkToUrl ? /*#__PURE__*/_react["default"].createElement("a", {
      href: linkToUrl,
      target: "_blank"
    }, imageComponent(src)) : imageComponent(src));
  },
  button: function button(children, _ref37, _ref38) {
    var name = _ref37.name,
        alignment = _ref37.alignment,
        url = _ref37.url,
        size = _ref37.size;
    var key = _ref38.key;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      style: _extends({}, selectedTheme['button-wrapper'], selectedTheme['ALIGN_BLOCK_' + alignment])
    }, url ? /*#__PURE__*/_react["default"].createElement("a", {
      href: url,
      target: "_blank"
    }, buttonComponent(name, size)) : buttonComponent(name, size));
  },
  mention: function mention(children, _ref39, _ref40) {
    var _mention = _ref39.mention;
    var key = _ref40.key;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: key
    }, '{{' + _mention.attr + '}}');
  },
  footer: function footer(children, _ref41, _ref42) {
    var address1 = _ref41.address1,
        address2 = _ref41.address2,
        twitterUrl = _ref41.twitterUrl,
        facebookUrl = _ref41.facebookUrl,
        instagramUrl = _ref41.instagramUrl,
        linkedinUrl = _ref41.linkedinUrl;
    var key = _ref42.key;
    return /*#__PURE__*/_react["default"].createElement("table", {
      key: key,
      style: _extends({}, selectedTheme['footer-wrapper'])
    }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['footer-td']
    }, "Address:", /*#__PURE__*/_react["default"].createElement("br", null), address1 || 'address line 1', /*#__PURE__*/_react["default"].createElement("br", null), address2 || 'address line2')), (twitterUrl || facebookUrl || instagramUrl || linkedinUrl) && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['footer-td']
    }, "Connect with us:", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, selectedTheme['footer-social-media-icon-wrapper'])
    }, facebookUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: facebookUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, selectedTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.FacebookImg,
      alt: "facebook",
      width: "100%",
      height: "100%"
    }))), twitterUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: twitterUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, selectedTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.TwitterImg,
      alt: "twitter",
      width: "100%",
      height: "100%"
    }))), instagramUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: instagramUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, selectedTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.InstagramImg,
      alt: "instagram",
      width: "100%",
      height: "100%"
    }))), linkedinUrl && /*#__PURE__*/_react["default"].createElement("a", {
      href: linkedinUrl
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, selectedTheme['footer-social-media-icon'])
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _FooterImages.LinkedinImg,
      alt: "linkedin",
      width: "100%",
      height: "100%"
    })))))));
  }
};

var isEmptyRaw = function isEmptyRaw(raw) {
  return !raw || !raw.blocks || raw.blocks.length === 1 && raw.blocks[0].text === '';
};

var options = {
  //TODO: removed options like code cleanup since it's remove the line spaces. Create a custom export which works based on megadraft json output
  cleanup: false
  /*
   cleanup: {
   after: 'all',
   types: 'all',
   split: true,
   }
   */

};

var exportHtml = function exportHtml(editorState) {
  if (editorState) {
    var raw = (0, _draftJs.convertToRaw)(editorState.getCurrentContent());
    var isEmpty = isEmptyRaw(raw);
    var rendered = (0, _redraft["default"])(raw, {
      inline: inline,
      blocks: blocks,
      entities: entities
    }, options);
    return /*#__PURE__*/_react["default"].createElement("table", {
      cellPadding: "0",
      cellSpacing: "0",
      width: "100%",
      style: Object.assign({}, {
        textAlign: "center"
      }, selectedTheme['email-wrapper'])
    }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("table", {
      cellPadding: "0",
      cellSpacing: "0",
      width: "700",
      style: Object.assign({}, {
        borderCollapse: "collapse",
        margin: "20px auto"
      }, selectedTheme['email-wrapper-content'])
    }, /*#__PURE__*/_react["default"].createElement("tbody", null, isEmpty ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "Preview-empty"
    }, "No Content"))) : rendered)))), !isEmpty && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      style: selectedTheme['unsubscribe-link']
    }, "Looking to ", /*#__PURE__*/_react["default"].createElement("a", {
      href: window.location.origin + "/unsubscribe/{{_id}}{{id}}/{{owner_id}}/{{email}}",
      target: "_blank"
    }, "unsubscribe"), "?"), " ")));
  }

  return null;
};

var _default = exportHtml;
exports["default"] = _default;
module.exports = exports.default;